"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getMaxFavoriteSuggestionCounts_1 = require("./getMaxFavoriteSuggestionCounts");
var owa_mail_favorites_store_1 = require("owa-mail-favorites-store");
var searchCache_1 = require("owa-recipient-cache/lib/selectors/searchCache");
function getFavoritePeopleSuggestions(findText) {
    var existingFavoritePeople = [];
    owa_mail_favorites_store_1.favoritesStore.favoritesPersonaNodes.forEach(function (personaNode) {
        existingFavoritePeople.push({
            EmailAddress: {
                EmailAddress: personaNode.mainEmailAddress,
            },
        });
    });
    var maxPeopleSuggestions = getMaxFavoriteSuggestionCounts_1.default().people;
    var topRecipients = searchCache_1.default(findText, maxPeopleSuggestions /* numberOfResults */, existingFavoritePeople /* recipientsToExclude */, ['PrivateDL', 'PublicDL', 'GroupMailbox'] /* mailboxTypesToExclude */);
    return topRecipients.map(function (recipient) {
        return {
            data: recipient,
            id: recipient.PersonaId.Id,
            type: 1 /* Persona */,
            relevance: 0 /* Relevance scores will be supplied by providers in the future */,
        };
    });
}
exports.default = getFavoritePeopleSuggestions;
//# sourceMappingURL=getFavoritePeopleSuggestions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-find-favorites/lib/actions/helpers/getFavoritePeopleSuggestions.js
// module id = 6278
// module chunks = 68